import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { apiSync, FAQ as FAQType } from "@/lib/api";
const FAQ = () => {
  const faqs = apiSync.getFAQs();

  // Generate JSON-LD structured data for FAQs
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };
  return <div className="min-h-screen flex flex-col">
      <SEOHead title="Veelgestelde Vragen | Alpacaboerderij Dordrecht" description="Antwoorden op veelgestelde vragen over reserveren, dieetwensen, bereikbaarheid en meer bij Alpacaboerderij Dordrecht." canonical="/faq/" />
      
      {/* JSON-LD structured data */}
      {faqs.length > 0 && <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(faqSchema).replace(/</g, '\\u003c')
    }} />}
      
      <Header />
      
      <main className="flex-1">
        {/* Hero */}
        <section className="bg-gradient-to-br from-primary/10 via-secondary/20 to-background py-20" aria-labelledby="faq-hero-heading">
          <div className="container text-center">
            <h1 id="faq-hero-heading" className="text-4xl md:text-6xl font-bold mb-6 animate-fade-in motion-reduce:animate-none">Veelgestelde vragen</h1>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Heb je vragen? Check hier of je vraag er misschien al bij staat!
            </p>
          </div>
        </section>

        {/* FAQs */}
        <section className="py-20" aria-labelledby="faq-list-heading">
          <h2 id="faq-list-heading" className="sr-only">Veelgestelde vragen en antwoorden</h2>
          <div className="container max-w-4xl">
            <Accordion type="single" collapsible className="space-y-4">
              {faqs.map(faq => <AccordionItem key={faq.id} value={`item-${faq.id}`} className="border border-border rounded-2xl px-6 bg-card hover:bg-muted/30 transition-colors">
                  <AccordionTrigger className="text-left text-lg font-semibold hover:no-underline py-6">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground pb-6 whitespace-pre-line">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>

            {/* Contact CTA */}
            <aside className="mt-16 text-center p-8 bg-gradient-to-br from-primary/10 to-accent/10 rounded-3xl" aria-labelledby="contact-cta-heading">
              <h3 id="contact-cta-heading" className="text-2xl font-bold mb-4">Vraag staat er niet tussen?</h3>
              <p className="text-lg text-muted-foreground mb-6">
                Neem gerust contact met ons op! We helpen je graag verder.
              </p>
              <Link to="/contact" className="text-primary font-semibold hover:underline">
                Ga naar contactpagina
              </Link>
            </aside>
          </div>
        </section>
      </main>

      <Footer />
    </div>;
};
export default FAQ;
